import { fetchAction } from 'barnyard/utils/';
import * as constants from '../constants';

export const glCodesFetch = () => dispatch => fetchAction(
  dispatch,
  constants.GL_CODES_FETCH,
  { },
  {
    url: '/api/glcodes/'
  }
);

export const glCodeCreate = (body, callback) => dispatch => fetchAction(
  dispatch,
  constants.GL_CODE_CREATE,
  { },
  {
    url: '/api/glcodes/',
    method: 'POST',
    body,
    postSuccess: callback
  }
);

export const glCodeDelete = id => dispatch => fetchAction(
  dispatch,
  constants.GL_CODE_DELETE,
  { id },
  {
    url: `/api/glcodes/${id}/`,
    method: 'DELETE',
  }
);

export const glCodeUpdate = (body, callback) => dispatch => fetchAction(
  dispatch,
  constants.GL_CODE_UPDATE,
  { id: body.id },
  {
    url: `/api/glcodes/${body.id}/`,
    method: 'PATCH',
    body,
    postSuccess: callback
  }
);
